export default __webpack_public_path__ + "static/media/1456.71733be5.png";